const DAY_IN_MS = 24 * 60 * 60 * 1000;
const ODESSA_TIME_ZONE = "America/Chicago";

export const formatCOIDate = (value: string | null | undefined) => {
  if (!value) return "—";
  const [year, month, day] = value.slice(0, 10).split("-");
  if (!year || !month || !day) return value;
  return `${month}/${day}/${year}`;
};

export const formatCOIInteger = (
  value: number | string | null | undefined,
) => {
  if (value === null || value === undefined || value === "") return "—";
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return String(value);
  return Math.trunc(parsed).toLocaleString("en-US");
};

const odessaTodayUtc = () => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: ODESSA_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date());
  const value = Object.fromEntries(
    parts
      .filter(({ type }) => type !== "literal")
      .map(({ type, value: partValue }) => [type, Number(partValue)]),
  );
  return Date.UTC(value.year, value.month - 1, value.day);
};

export const calculateCOINewRuntime = (
  reinstallDate: string | null | undefined,
) => {
  if (!reinstallDate) return null;
  const [year, month, day] = reinstallDate.slice(0, 10).split("-").map(Number);
  if (!year || !month || !day) return null;
  const reinstallUtc = Date.UTC(year, month - 1, day);
  return Math.max(0, Math.floor((odessaTodayUtc() - reinstallUtc) / DAY_IN_MS));
};
